// Traduções das áreas, da tela de áreas, do seletor e da página do DP — coletadas
// por glob em core/i18n/messages.ts.
export default {
  pt: {
    'areas.logistica.nome': 'Logística',
    'areas.logistica.descricao': 'Operação, viagens, jornada, frota e cadastros',
    'areas.administrativo.nome': 'Administrativo',
    'areas.administrativo.descricao': 'Usuários, cargos e auditoria',
    'areas.dp.nome': 'Departamento Pessoal',
    'areas.dp.descricao': 'Rotinas do departamento pessoal',
    'areas.abastecimento.nome': 'Abastecimento',
    'areas.abastecimento.descricao': 'Lançamento de multas e sinistros para o DP',
    'areas.farm.nome': 'Vertical Farm',
    'areas.farm.descricao': 'Fazendas, produção e financeiro do grupo',
    'areas.topo.produto': 'Central',
    'areas.topo.administrador': 'Administrador',
    'areas.saudacao.manha': 'Bom dia, {{nome}}',
    'areas.saudacao.tarde': 'Boa tarde, {{nome}}',
    'areas.saudacao.noite': 'Boa noite, {{nome}}',
    'areas.grade.rotulo': 'Áreas do sistema',
    'areas.card.entrar': 'Entrar',
    'areas.card.entrarEm': 'Entrar em {{area}}',
    'areas.seletor.rotulo': 'Trocar de área, atual {{area}}',
    'areas.seletor.todas': 'Todas as áreas',
  },
  en: {
    'areas.logistica.nome': 'Logistics',
    'areas.logistica.descricao': 'Operations, trips, working hours, fleet and records',
    'areas.administrativo.nome': 'Administration',
    'areas.administrativo.descricao': 'Users, positions and audit',
    'areas.dp.nome': 'Personnel Department',
    'areas.dp.descricao': 'Personnel department routines',
    'areas.abastecimento.nome': 'Fueling',
    'areas.abastecimento.descricao': 'Traffic fines and claims sent to the Personnel Department',
    'areas.farm.nome': 'Vertical Farm',
    'areas.farm.descricao': 'The group farms, production and finance',
    'areas.topo.produto': 'Central',
    'areas.topo.administrador': 'Administrator',
    'areas.saudacao.manha': 'Good morning, {{nome}}',
    'areas.saudacao.tarde': 'Good afternoon, {{nome}}',
    'areas.saudacao.noite': 'Good evening, {{nome}}',
    'areas.grade.rotulo': 'System areas',
    'areas.card.entrar': 'Enter',
    'areas.card.entrarEm': 'Enter {{area}}',
    'areas.seletor.rotulo': 'Switch area, current {{area}}',
    'areas.seletor.todas': 'All areas',
  },
  es: {
    'areas.logistica.nome': 'Logística',
    'areas.logistica.descricao': 'Operación, viajes, jornada, flota y registros',
    'areas.administrativo.nome': 'Administrativo',
    'areas.administrativo.descricao': 'Usuarios, cargos y auditoría',
    'areas.dp.nome': 'Departamento de Personal',
    'areas.dp.descricao': 'Rutinas del departamento de personal',
    'areas.abastecimento.nome': 'Abastecimiento',
    'areas.abastecimento.descricao': 'Registro de multas y siniestros para el departamento de personal',
    'areas.farm.nome': 'Vertical Farm',
    'areas.farm.descricao': 'Haciendas, producción y finanzas del grupo',
    'areas.topo.produto': 'Central',
    'areas.topo.administrador': 'Administrador',
    'areas.saudacao.manha': 'Buenos días, {{nome}}',
    'areas.saudacao.tarde': 'Buenas tardes, {{nome}}',
    'areas.saudacao.noite': 'Buenas noches, {{nome}}',
    'areas.grade.rotulo': 'Áreas del sistema',
    'areas.card.entrar': 'Entrar',
    'areas.card.entrarEm': 'Entrar en {{area}}',
    'areas.seletor.rotulo': 'Cambiar de área, actual {{area}}',
    'areas.seletor.todas': 'Todas las áreas',
  },
}
